// extracted by mini-css-extract-plugin
export default {"WarningIcon":"Icon_WarningIcon__uORzV","WarningIcon__Red":"Icon_WarningIcon__Red__6KqeZ"};